export const languageMappings = {
  en: "en_US",
  de: "de",
  es: "es",
  fr: "fr",
  it: "it",
  pl: "pl_PL",
  pt: "pt",
};

export const pt = {
  serverCallPrecheckFailedMissingConnector:
    "Dados do conector para chamada do servidor ausentes.",
  serverCallPrecheckFailedModelIsNew: "O modelo \u00E9 novo.",
  fav_parent_id: "Localização",
  fav_favorite_name: "Nome",
  fav_size: "Tamanho",
  fav_ungrouped: "Desagrupado",
  name: "Nome",
  type: "Tipo",
  version: "Vers\u00E3o",
  state: "Estado",
  favorite: "Favorito",
  toggleDetails: "Alternar detalhes",
  parentID: "ID pai",
};

export const it = {
  ToolbarAria: "Barra degli strumenti tabella",
  ToolbarItemFilter: "Mostra filtri",
  ToolbarItemFilterAria: "Mostra pannello filtri",
  ToolbarItemOpen: "Apri",
  ToolbarItemDownload: "Scarica",
  ToolbarItemBrowse: "Sfoglia",
  ToolbarItemCopy: "Copia",
  ToolbarItemEmailLink: "Invia come collegamento",
  ToolbarItemEmailLinkShort: "Invia come collegamento",
  ToolbarItemPaste: "Incolla",
  ToolbarItemMove: "Sposta",
  ToolbarItemShare: "Condividi",
  ToolbarItemSendTo: "Invia a",
  ToolbarItemNavigate: "Visita",
  ToolbarItemViewProperties: "Propriet\u00E0",
  ToolbarItemVersionHistory: "Cronologia versioni",
  ToolbarItemDelete: "Elimina",
  ToolbarItemReserve: "Riserva",
  ToolbarItemUnreserve: "Non riservare",
  ToolbarItemLock: "Blocca",
  ToolbarItemUnlock: "Sblocca",
  ToolbarItemEdit: "Modifica",
  ToolbarItemRename: "Rinomina",
  ToolbarItemRenameFavorite: "Rinomina preferito",
  ToolbarItemOpenSavedQuery: "Apri",
  ToolbarItemExecuteSavedQuery: "Esegui",
  ToolbarItemInfo: "Propriet\u00E0",
  ToolbarItemTimeline: "Linea temporale",
  ToolbarItemToggleTableLayout: "Attiva/Disattiva layout",
  ToolbarItemSettings: "Impostazioni",
  ToolbarItemAddFolder: "Cartella",
  ToolbarItemAddDocument: "Documento",
  ToolbarItemAdd: "Aggiungi",
  ToolbarItemAddItem: "Aggiungi elemento",
  ToolbarItemAddVersion: "Aggiungi versione",
  ToolbarItemAddCategories: "Aggiungi categorie",
  ToolbarItemMore: "Altre azioni",
  ToolbarItemPrint: "Stampa",
  ToolbarItemOriginalEdit: "Modifica originale",
  ToolbarItemOriginalShare: "Condividi originale",
  ToolbarItemOriginalReserve: "Prenota originale",
  ToolbarItemOriginalUnreserve: "Rilascia originale",
  ToolbarItemOriginalCopy: "Copia originale",
  ToolbarItemOriginalMove: "Sposta originale",
  ToolbarItemOriginalDownload: "Scarica originale",
  ToolbarItemOriginalDelete: "Elimina originale",
  ToolbarItemCopyLink: "Copia collegamento",
  ToolbarItemOriginalCopyLink: "Copia collegamento originale",
  ToolbarItemPermissions: "Visualizza autorizzazioni",
  ToolbarItemDeletePermission: "Rimuovi dalla lista",
  ToolbarItemEditPermission: "Modifica autorizzazioni",
  ToolbarItemApplyPermission: "Applica autorizzazioni ai sottoelementi",
  ToolbarItemChangeOwnerPermission: "Cambia proprietario",
  ToolbarItemRemoveCollectionItems: "Rimuovi dalla raccolta",
  ToolbarItemInformation: "Propriet\u00E0",
  ToolbarGoToLocation: "Vai al percorso",
  ToolbarCollect: "Raccogli",
  ToolbarItemZipAndDownload: "Scarica",
  ToolbarItemGoBack: "Torna indietro",
  ToolbarItemTreeBrowse: "Mostra struttura di navigazione",
  MenuItemUploadFile: "Carica file",
  MenuItemAddNewFolder: "Aggiungi nuova cartella",
  MenuItemZipAndDownload: "Scarica",
  MenuItemCopy: "Copia",
  MenuItemMove: "Sposta",
  MenuItemEmailLink: "Collegamento e-mail",
  MenuItemShare: "Condividi",
  MenuItemReserve: "Riserva",
  MenuItemUnreserve: "Non riservare",
  MenuItemDelete: "Elimina",
  MenuItemSendToDevice: "Invia al dispositivo",
  MenuItemRename: "Rinomina",
  MenuItemTimeline: "Linea temporale",
  MenuItemInformation: "Propriet\u00E0",
  MenuItemCopyLink: "Copia collegamento",
  ToolbarItemComment: "Commento",
  ToolbarItemShowDescription: "Mostra descrizione",
  ToolbarItemConfiguration: "Configurazione",
  ToolbarItemMaximizeWidgetView: "Ingrandisci vista widget",
  ToolbarItemRestoreWidgetViewSize: "Ripristina dimensione vista widget",
  AddUserOrGroups: "Aggiungi utente o gruppi",
  AddOwnerOrGroup: "Aggiungi proprietario o gruppo proprietario",
  RestorePublicAccess: "Ripristina accesso pubblico",
  AddToolbarItemsTitle: "Aggiungi {0}",
  ToolbarItemThumbnail: "Visualizzazione griglia",
  ToolbarItemListView: "Visualizzazione elenco",
  ThumbnailTitle: "Visualizzazione griglia",
  ListViewTitle: "Visualizzazione elenco",
  ToolbarItemDocPreview: "Visualizza",
  CreateRelease: "Crea release",
  CreateRevision: "Crea revisione",
  ToolbarItemViewReleases: "Mostra release",
  compoundDocument: "Documento composito",
  Reorganize: "Riorganizza",
};

export const de = {
  BackButtonToolItem: "Zurück",
  PageWidgetToolItem: "Open Full Page Workspace",
  SearchToolItem: "Suche von hier aus",
  SearchFromHerePlaceHolder: "Suche von hier aus",
  CloseToolTip: "Schließen",
};
